import React from "react";
import { Loader } from "../../index";
import styles from "./CustomLayoutView.module.scss";

export default () => {
  return (
    <div className={styles.customLayoutWrapper}>
      <Loader />
    </div>
  );
};
